import { assertNever } from '@onyx/utils/typescript';

export const appendHeaders = (
  headers: HeadersInit | undefined,
  additional: Record<string, string>
): HeadersInit => {
  if (headers instanceof Headers) {
    Object.entries(additional).forEach(([key, value]) => {
      headers.set(key, value);
    });
    return headers;
  }

  if (Array.isArray(headers)) {
    return [...headers, ...Object.entries(additional)];
  }

  if (headers instanceof Object) {
    return {
      ...headers,
      ...additional,
    };
  }

  /* istanbul ignore else */
  if (!headers) {
    const newHeaders = new Headers();
    Object.entries(additional).forEach(([key, value]) => {
      newHeaders.set(key, value);
    });
    return newHeaders;
  }

  // ignore this line for coverage as this is just for type checking
  /* istanbul ignore next */
  return assertNever(headers);
};
